import React from 'react';
import { Navigate, Outlet, NavLink } from 'react-router-dom';
import { Layout, Typography, Button, Space, theme } from 'antd';
import { LogoutOutlined, ReadOutlined, PictureOutlined, TeamOutlined, AppstoreOutlined, DollarOutlined, BulbOutlined, SmileOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';

const { Header, Content } = Layout;
const { Title } = Typography;

const navLinkStyle = (isActive: boolean, primary: string, secondary: string): React.CSSProperties => ({
  padding: '4px 12px',
  borderRadius: 6,
  fontWeight: isActive ? 600 : 400,
  color: isActive ? primary : secondary,
  background: isActive ? `color-mix(in srgb, ${primary} 10%, transparent)` : 'transparent',
  textDecoration: 'none',
  fontSize: 14,
  display: 'inline-flex',
  alignItems: 'center',
});

const AppLayout: React.FC = () => {
  const { token, logout } = useAuth();
  const { token: tok } = theme.useToken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Layout style={{ minHeight: '100vh', background: tok.colorBgLayout }}>
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 32px',
          background: '#fff',
          boxShadow: '0 1px 4px rgba(0,21,41,0.08)',
          position: 'sticky',
          top: 0,
          zIndex: 100,
        }}
      >
        <Space size={24}>
          <Space size={10}>
            <ReadOutlined style={{ fontSize: 22, color: tok.colorPrimary }} />
            <Title level={4} style={{ margin: 0, color: tok.colorText }}>
              BePrime Admin
            </Title>
          </Space>
          <Space size={4}>
            <NavLink to="/courses" style={({ isActive }) => navLinkStyle(isActive, tok.colorPrimary, tok.colorTextSecondary)}>
              <ReadOutlined style={{ marginRight: 6 }} />Courses
            </NavLink>
            <NavLink to="/bundles" style={({ isActive }) => navLinkStyle(isActive, tok.colorPrimary, tok.colorTextSecondary)}>
              <AppstoreOutlined style={{ marginRight: 6 }} />Bundles
            </NavLink>
            <NavLink to="/thoughts" style={({ isActive }) => navLinkStyle(isActive, tok.colorPrimary, tok.colorTextSecondary)}>
              <BulbOutlined style={{ marginRight: 6 }} />Thoughts
            </NavLink>
            <NavLink to="/images" style={({ isActive }) => navLinkStyle(isActive, tok.colorPrimary, tok.colorTextSecondary)}>
              <PictureOutlined style={{ marginRight: 6 }} />Images
            </NavLink>
            <NavLink to="/users" style={({ isActive }) => navLinkStyle(isActive, tok.colorPrimary, tok.colorTextSecondary)}>
              <TeamOutlined style={{ marginRight: 6 }} />Users
            </NavLink>
            <NavLink to="/yookassa-payments" style={({ isActive }) => navLinkStyle(isActive, tok.colorPrimary, tok.colorTextSecondary)}>
              <DollarOutlined style={{ marginRight: 6 }} />Payments
            </NavLink>
            <NavLink to="/csat" style={({ isActive }) => navLinkStyle(isActive, tok.colorPrimary, tok.colorTextSecondary)}>
              <SmileOutlined style={{ marginRight: 6 }} />CSAT
            </NavLink>
          </Space>
        </Space>
        <Button
          type="text"
          icon={<LogoutOutlined />}
          onClick={logout}
          style={{ color: tok.colorTextSecondary }}
        >
          Logout
        </Button>
      </Header>
      <Content style={{ padding: '28px 32px', maxWidth: 1280, margin: '0 auto', width: '100%' }}>
        <Outlet />
      </Content>
    </Layout>
  );
};

export default AppLayout;
